export default "__VITE_ASSET__C$WImu6F__"